/**
 * @flow
 */

/* eslint-disable */

'use strict';


/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type AggregatesListingsSEOLinks_popularSearches$ref: FragmentReference;
declare export opaque type AggregatesListingsSEOLinks_popularSearches$fragmentType: AggregatesListingsSEOLinks_popularSearches$ref;
export type AggregatesListingsSEOLinks_popularSearches = $ReadOnlyArray<{|
  +h1: string,
  +slug: string,
  +$refType: AggregatesListingsSEOLinks_popularSearches$ref,
|}>;
export type AggregatesListingsSEOLinks_popularSearches$data = AggregatesListingsSEOLinks_popularSearches;
export type AggregatesListingsSEOLinks_popularSearches$key = $ReadOnlyArray<{
  +$data?: AggregatesListingsSEOLinks_popularSearches$data,
  +$fragmentRefs: AggregatesListingsSEOLinks_popularSearches$ref,
  ...
}>;
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "AggregatesListingsSEOLinks_popularSearches",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "h1",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    }
  ],
  "type": "AggregatorCustomPage",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = '38ed1b2432b72f2281925fd8fbb7c098';

export default node;
